import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PainPointsSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2 h-2 rounded-full bg-accent-500" />
              <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400">
                {t('painPoints.label')}
              </p>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              {t('painPoints.title')} <span className="italic text-accent-600">{t('painPoints.highlight')}</span>
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-8 max-w-lg">
              {t('painPoints.subtitle')}
            </p>

            <div className="space-y-4 mb-10">
              {[1, 2, 3, 4, 5].map((idx) => (
                <div key={idx} className="flex items-start gap-3 group">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center mt-0.5 group-hover:bg-accent-200 transition-colors duration-200">
                    <i className="ri-close-line text-accent-600 text-sm" />
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {t(`painPoints.item${idx}`)}
                  </p>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-2xl p-6 border border-accent-200/60 inline-block">
              <p className="font-heading text-lg font-bold text-foreground-950 mb-3">
                {t('painPoints.cta')}
              </p>
              <button
                type="button"
                onClick={() => navigate('/booking')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {t('painPoints.ctaButton')}
                <i className="ri-arrow-right-line" />
              </button>
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="relative h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20solitary%20professional%20sitting%20at%20a%20clean%20modern%20desk%20in%20a%20dimly%20lit%20minimalist%20office%20space%20late%20evening%20atmosphere%20with%20a%20laptop%20screen%20glowing%20faintly%20casting%20soft%20blue%20light%20on%20their%20face%20the%20person%20looks%20thoughtful%20and%20slightly%20frustrated%20with%20a%20stack%20of%20printed%20CVs%20and%20job%20application%20notes%20scattered%20on%20the%20desk%20warm%20desk%20lamp%20creating%20a%20small%20pool%20of%20light%20in%20an%20otherwise%20shadowy%20room%20the%20scene%20conveys%20the%20quiet%20frustration%20of%20job%20searching%20alone%20at%20night%20cinematic%20composition%20with%20deep%20shadows%20and%20soft%20highlights%20editorial%20photography%20style%20with%20emotional%20depth&width=700&height=900&seq=pain-points-frustration-01&orientation=portrait"
                alt={t('painPoints.label')}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/50 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}